export const getDevelopmentSummary = (plots) => {
  const plotBedrooms = [];
  const plotTypes = [];
  let plotMinBedrooms;
  let plotMaxBedrooms;
  let plotBedroomRange;
  let plotTypeRange;

  if (plots && plots.length > 0) {
    plots
      .filter((plot) => !!plot)
      .forEach(({ bedrooms, propertyType }) => {
        const isSinglular = plots.length === 1 ? `s` : ``;
        if (!plotBedrooms.includes(bedrooms)) {
          plotBedrooms.push(bedrooms);
        }
        if (!plotTypes.includes(`${propertyType}${!isSinglular ? `s` : ''}`)) {
          plotTypes.push(`${propertyType}${!isSinglular ? `s` : ''}`);
        }
      });

    plotMinBedrooms = Math.min(...plotBedrooms);
    plotMaxBedrooms = Math.max(...plotBedrooms);
    if (plotMinBedrooms === 0) {
      plotBedroomRange = plotBedrooms.length > 1 ? `Studio - ${plotMaxBedrooms}` : plotBedrooms[0];
    } else {
      plotBedroomRange = plotBedrooms.length > 1 ? `${plotMinBedrooms} - ${plotMaxBedrooms}` : plotBedrooms[0];
    }

    plotTypeRange = plotTypes.length > 1 ? plotTypes.join(' & ') : plotTypes[0];

    // Catch Single studio

    if (plotBedroomRange === 0) {
      plotBedroomRange = 'Studio';
    }
  }

  const developmentSummaryData = {
    plotBedrooms,
    plotTypes,
    plotMinBedrooms,
    plotMaxBedrooms,
    plotBedroomRange,
    plotTypeRange,
    summaryText:
      plotTypeRange !== 'Land'
        ? `${plotBedroomRange} ${plotBedroomRange !== 'Studio' ? 'Bedroom' : ''} ${plotTypeRange}`
        : '',
  };
  return developmentSummaryData;
};
